import React, {useRef} from 'react';
import Slider from 'react-slick';
import ReactDOM from "react-dom/client";
import LocalizedStrings from "react-localization";

let strings = new LocalizedStrings({
    ru: {
        why_us: "Почему мы?",
        title_advantage_1: "Компенсация расходов за обучение детей",
        title_advantage_2: "Член союза по плаванию в Эстонии",
        title_advantage_3: "Ваши занятия не пропадают",
        title_advantage_4: "Удовольствие и польза",
        title_advantage_5: "Удобное время",
        title_advantage_6: "Выгодные цены",
        description_advantage_1: "Мы являемся официальной школой по интересам, и программа обучения одобрена министерством образования Эстонии, поэтому Вы сможете компенсировать расходы за обучение",
        description_advantage_2: "Присоединившись к нашему клубу, Вы или Ваш ребенок сможет представлять наш клуб на соревнованиях по плаванию, получая ценный опыт и поддержку спортивной деятельности",
        description_advantage_3: "Мы ценим ваше время и хотим, чтобы ни одно занятие не пропало даром из-за болезни. Если ваш ребенок не может посетить занятие, мы предоставим бесплатную возможность посетить занятие в другой группе",
        description_advantage_4: "Научно доказано, что спорт способствует развитию физических навыков, улучшению психологического состояния, снижает риск развития ряда болезней и укрепляет иммунитет. Наша программа создана для сохранения и укрепления здоровья, а также для получения удовольствия от плавания и профессионального развития навыков",
        description_advantage_5: "Мы понимаем, что ваше расписание может быть загружено. Поэтому мы предлагаем гибкое расписание наших занятий, чтобы вы могли выбрать удобное время. Наш клуб работает круглый год, чтобы вам было удобно начать и продолжить заниматься",
        description_advantage_6: "У нас вы найдете низкие цены, бесплатное пробное занятие и регулярные акции. Не упустите шанс, отправьте заявку или зарегистрируйтесь на занятие и начните плавать уже сейчас!"
    },
    et: {
        why_us: "Miks meie?",
        title_advantage_1: "Laste koolituskulude hüvitamine",
        title_advantage_2: "Eesti Ujumisliidu liige",
        title_advantage_3: "Teie õppetunnid ei lähe kaduma",
        title_advantage_4: "Nauding ja kasu",
        title_advantage_5: "Mugav aeg",
        title_advantage_6: "Soodsad hinnad",
        description_advantage_1: "Oleme ametlik huvikool ja õppekava on Eesti haridusministeeriumi poolt heaks kiidetud, seega saate oma õppemaksu kompenseerida",
        description_advantage_2: "Meie klubiga liitudes saate teie või teie laps esindada meie klubi ujumisvõistlustel, saades väärtuslikke kogemusi ja tuge sportlikuks tegevuseks.",
        description_advantage_3: "Me hindame teie aega ja soovime tagada, et ükski seanss ei läheks haiguse tõttu raisku. Kui teie laps ei saa osaleda tunnis, pakume tasuta võimalust osaleda teises tunnis mõnes teises rühmas",
        description_advantage_4: "On teaduslikult tõestatud, et sport aitab arendada füüsilisi oskusi, parandab psühholoogilist heaolu, vähendab mitmete haiguste riski ja tugevdab immuunsust. Meie programm on mõeldud selleks, et aidata teil säilitada ja parandada oma tervist, samuti nautida ujumist ja arendada oma oskusi professionaalselt",
        description_advantage_5: "Me mõistame, et teie ajakava võib olla hõivatud. Seepärast pakume oma tundide paindlikku ajakava, nii et saate valida endale sobiva aja. Meie klubi on avatud aastaringselt, et teil oleks mugav alustada ja jätkata oma tunde",
        description_advantage_6: "Pakume madalaid hindu, tasuta proovitunde ja regulaarseid kampaaniaid. Ära jäta oma võimalust kasutamata, esita avaldus või registreeru tunnile ja hakka kohe ujuma!"
    },
});

const language = localStorage.getItem('language');
strings.setLanguage(language);

const compensation = {
    image: "images/advantages1.png",
    title: strings.title_advantage_1,
    description: strings.description_advantage_1
};
const trainingTransfer = {
    image: "images/advantages3.png",
    title: strings.title_advantage_3,
    description: strings.description_advantage_3
};
const pleasureAndBenefit = {
    image: "images/advantages4.png",
    title: strings.title_advantage_4,
    description: strings.description_advantage_4
};
const convenientTime = {
    image: "images/advantages5.png",
    title: strings.title_advantage_5,
    description: strings.description_advantage_5
};
const swimmingUnion = {
    image: "images/advantages2.png",
    title: strings.title_advantage_2,
    description: strings.description_advantage_2
};
const favorablePrice = {
    image: "images/advantages6.png",
        title: strings.title_advantage_6,
        description: strings.description_advantage_6
};

const advantages = [
    compensation,
    swimmingUnion,
    trainingTransfer,
    pleasureAndBenefit,
    convenientTime,
    favorablePrice,
];

const personalTrainingAdvantages = [swimmingUnion, pleasureAndBenefit, convenientTime, favorablePrice];


const AdvantagesSlider = ({advantages}) => {
    const sliderRef = useRef(null);

    const handleNextSlide = () => {
        sliderRef.current.slickNext();
    };

    const handlePreviousSlide = () => {
        sliderRef.current.slickPrev();
    };


    const settings = {
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };
    return (
        <div className="max-w-full">
            <div className="flex items-center justify-between mb-12 lg:mb-14">
                <h2 className="mx-auto w-fit xl:text-5xl text-4xl font-normal text-dark-main uppercase">
                    {strings.why_us}
                </h2>
            </div>
            <div className="">
                <Slider ref={sliderRef} {...settings}>
                    {advantages.map((advantage, index) => (
                        <div className="slick-slide" key={index}>
                            <div
                                className="flex flex-col m-auto w-64 h-[496px] sm:w-96 sm:h-[422px] p-4 lg:p-6 sm:mr-4 lg:mr-7 rounded-3xl bg-sky-100">
                                <img className="h-16 w-16 mb-7 lg:mb-9" src={advantage.image}
                                     alt={`${advantage.title}`}/>
                                <div className="">
                                    <p className="text-xl lg:text-2xl font-bold mb-3.5">{advantage.title}</p>
                                    <p className="text-sm lg:text-base mb-4">{advantage.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
            <div className="hidden md:block text-center mt-14">
                <button className="custom-prev-button" onClick={handlePreviousSlide}>
                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M26 45.5C15.2304 45.5 6.5 36.7696 6.5 26C6.5 15.2304 15.2304 6.5 26 6.5C36.7696 6.5 45.5 15.2304 45.5 26C45.5 36.7696 36.7696 45.5 26 45.5Z"
                            stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M28.1667 19.5L21.6667 26L28.1667 32.5" stroke="#333333" strokeWidth="2"
                              strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <button className="custom-next-button" onClick={handleNextSlide}>
                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M26 45.5C36.7696 45.5 45.5 36.7696 45.5 26C45.5 15.2304 36.7696 6.5 26 6.5C15.2304 6.5 6.5 15.2304 6.5 26C6.5 36.7696 15.2304 45.5 26 45.5Z"
                            stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M23.8333 19.5L30.3333 26L23.8333 32.5" stroke="#333333" strokeWidth="2"
                              strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </div>
            <div className="md:hidden text-center mt-6">
                <button className="custom-prev-button" onClick={handlePreviousSlide}>
                    <svg width="36" height="36" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M26 45.5C15.2304 45.5 6.5 36.7696 6.5 26C6.5 15.2304 15.2304 6.5 26 6.5C36.7696 6.5 45.5 15.2304 45.5 26C45.5 36.7696 36.7696 45.5 26 45.5Z"
                            stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M28.1667 19.5L21.6667 26L28.1667 32.5" stroke="#333333" strokeWidth="2"
                              strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <button className="custom-next-button" onClick={handleNextSlide}>
                    <svg width="36" height="36" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M26 45.5C36.7696 45.5 45.5 36.7696 45.5 26C45.5 15.2304 36.7696 6.5 26 6.5C15.2304 6.5 6.5 15.2304 6.5 26C6.5 36.7696 15.2304 45.5 26 45.5Z"
                            stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M23.8333 19.5L30.3333 26L23.8333 32.5" stroke="#333333" strokeWidth="2"
                              strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>
    );
};
const section = document.getElementById("advantages");
if (section) {
    ReactDOM.createRoot(section).render(<AdvantagesSlider advantages={advantages}/>);
}

const sectionPersonalTraining = document.getElementById("personalTrainingAdvantages");
if (sectionPersonalTraining) {
    ReactDOM.createRoot(sectionPersonalTraining).render(<AdvantagesSlider advantages={personalTrainingAdvantages}/>);
}
